import React from 'react';
import { Paper, Typography } from '@mui/material';

const DashboardKpiCard = ({
  label,
  value,
  subLabel,
  icon,
  toneClassName,
  valueClassName,
  classes,
  onClick,
  title,
  ariaLabel,
}) => {
  const isClickable = typeof onClick === 'function';

  return (
    <Paper
      elevation={3}
      component={isClickable ? 'button' : 'div'}
      type={isClickable ? 'button' : undefined}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || title}
      className={` ${classes.kpiCard} ${isClickable ? classes.kpiCardClickable : ''} ${toneClassName || ''}`}
    >
      <div className={classes.kpiIconRow}>{icon}</div>
      <Typography className={classes.kpiLabel}>{label}</Typography>
      <Typography className={`${classes.kpiValue} ${valueClassName || ''}`}>{value}</Typography>
      <Typography className={classes.kpiSub}>{subLabel}</Typography>
    </Paper>
  );
};

export default DashboardKpiCard;
